import React from 'react';
import { CellProps } from 'react-table';
import { useAppDispatch } from 'utils/hooks/redux';
import useHttp from 'utils/hooks/useHttp';
import { CartTableItem } from '../../CartTable.model';
import DeleteCellView from './DeleteCell.view';
import { setQuantityToolbar } from 'store/slices/cart.slice';

type Props = CellProps<CartTableItem> & {
  refetch: () => Promise<void>;
  setLoading: (state: boolean) => void;
};

const DeleteCell: React.FC<Props> = (props: Props) => {
  const http = useHttp();
  const dispatch = useAppDispatch();

  const handleDeleteClick = async () => {
    props.setLoading(true);
    await http.order.delete(props.row.original.id).then((res) => {
      dispatch(setQuantityToolbar(res.data.total_quantity));
    });
    await props.refetch();
    props.setLoading(false);
  };

  return <DeleteCellView onDelete={handleDeleteClick}></DeleteCellView>;
};

DeleteCell.displayName = 'DeleteCell';

export default DeleteCell;
